import {Injectable} from '@angular/core';
import {YuColorDto} from 'yukit';
import {OrderDto} from '../../../Models/Purchases/Orders/order.interface';
import {OrderStatusEnum} from '../../../Shared/Enum/order-status.enum';
import {TransferDto} from '../../../Models/Warehouse/Transfers/transfer.interface';
import {TransferStatusEnum} from '../../../Shared/Enum/transfer-status.enum';
import {DeliveryNoteDto} from '../../../Models/Purchases/Delivery-notes/delivery-note.interface';
import {DeliveryNoteStatusEnum} from '../../../Shared/Enum/delivery-note-status.enum';
import {RankDto} from '../../../Models/Rrhh/Clock-In/clock-in-list.interface';
import {ClockInStatusEnum} from '../../../Shared/Enum/clock-in-status.enum';
import {EventDeliveryNoteDto, EventDto, EventOrderDto} from '../../../Models/Events/event.interface';
import {EventStatusEnum} from '../../../Shared/Enum/event-status.enum';
import {ScanStatusEnum} from '../../../Shared/Enum/scan-status.enum';

@Injectable({
  providedIn: 'root'
})
export class TagManagerService {

  /**
   * Obtener el color del estado
   *
   */
  public getColorTag(data: any, type: string): YuColorDto {

    if (!data) {
      return 'primary';
    }

    switch (type) {
      case 'order':
        return this.getColorTagOrder(data);

      case 'delivery-note':
        return this.getColorTagDeliveryNote(data);

      case 'transfer':
        return this.getColorTagTransfer(data);

      case 'scan':
        return this.getColorTagScan(data);

      case 'clock-in':
        return this.getColorTagClockInSignature(data);

      case 'event':
        return this.getColorTagEvent(data);

      default:
        return 'primary';
    }
  }


  /**
   * Obtener el color del estado del pedido
   *
   */
  private getColorTagOrder(order: OrderDto | EventOrderDto): YuColorDto {

    if (!order || typeof order !== 'object') {
      return 'light';
    }

    const key: number = ('id_estado' in order) ? order.id_estado : order.state_id;

    switch (key) {
      case OrderStatusEnum.pendent:
        return 'primary';

      case OrderStatusEnum.sent:
        return 'success';

      case OrderStatusEnum.inProcess:
        return 'info';

      case OrderStatusEnum.partiallyDelivered:
        return 'warning';

      case OrderStatusEnum.received:
        return 'info';

      default:
        return 'primary';
    }
  }


  /**
   * Obtener el color del estado del albarán/abono
   *
   */
  private getColorTagDeliveryNote(deliveryNote: DeliveryNoteDto | EventDeliveryNoteDto): YuColorDto {

    if (!deliveryNote || typeof deliveryNote !== 'object') {
      return 'light';
    }

    const key: number = ('id_estado' in deliveryNote) ? deliveryNote.id_estado : deliveryNote.state_id;

    switch (key) {
      case DeliveryNoteStatusEnum.new:
        return 'primary';

      case DeliveryNoteStatusEnum.generated:
        return 'info';

      case DeliveryNoteStatusEnum.signed:
        return 'success';

      case DeliveryNoteStatusEnum.billed:
        return 'warning';

      default:
        return 'primary';
    }
  }


  /**
   * Obtener el color del estado del traspaso
   *
   */
  private getColorTagTransfer(order: TransferDto): YuColorDto {
    switch (order.id_estado) {
      case TransferStatusEnum.pendent:
        return 'primary';

      case TransferStatusEnum.sent:
        return 'info';

      case TransferStatusEnum.received:
        return 'success';

      default:
        return 'primary';
    }
  }


  /**
   * Obtener el color del estado de la solicitud de firma en los fichajes
   *
   */
  private getColorTagClockInSignature(clockIn: RankDto): YuColorDto {
    switch (clockIn.id_estado_firma) {
      case ClockInStatusEnum.requested:
        return 'warning';

      case ClockInStatusEnum.signed:
        return 'success';

      case ClockInStatusEnum.rejected:
        return 'primary';

      default:
        return 'primary';
    }
  }


  /**
   * Obtener el color del estado del evento
   *
   */
  private getColorTagEvent(event: EventDto): YuColorDto {
    switch (event.id_estado) {
      case EventStatusEnum.Confirmed:
        return 'info';

      case EventStatusEnum.Starting:
        return 'warning';

      case EventStatusEnum.Started:
        return 'primary';

      case EventStatusEnum.InProgress:
        return 'success';

      case EventStatusEnum.Finished:
        return 'medium';

      case EventStatusEnum.Canceled:
        return 'error';

      default:
        return 'primary';
    }
  }


  /**
   * Obtener el color del estado del escaner
   *
   */
  private getColorTagScan(state: ScanStatusEnum): YuColorDto {
    switch (state) {
      case ScanStatusEnum.pending:
      case ScanStatusEnum.notProcessed:
        return 'warning';

      case ScanStatusEnum.rejected:
      case ScanStatusEnum.error:
      case ScanStatusEnum.incomplete:
      case ScanStatusEnum.duplicated:
        return 'error';

      case ScanStatusEnum.processed:
        return 'info';

      default:
        return 'primary';
    }
  }

}
